import { gql } from "@apollo/client";

export const GET_DISFAGIA = gql`
    query DisfagiaRIByDatosGeneralesId (
        $idDatosGenerales: Int!
    ) {
        disfagiaRIByDatosGeneralesId (
            idDatosGenerales: $idDatosGenerales
        ){
            disfagiaRI{
                idDisfagiaRI
                videodeglucion
                dIDisfagiaARI{
                    idComboRIValor
                }
                episodiosNeumonia
                dIAlimentacionActualRI{
                    idComboRIValor
                }
                dIHidratacionActualRI{
                    idComboRIValor
                }
                traqueostomia
                lucido
                compromisoMotor
                idComboRIValorKarnofsky
                actividadMotoraAlAlimentarse
                controlCefalico
                idComboRIValorControlPostural
                idComboRIValorDenticion
                idComboRIValorProtesis
                idComboRIValorEvaluacionFonoaudiologica
                idComboRIValorModuloDisfagia
                idComboRIValorNadaPorBoca
                idComboRIValorHidratacion
                idComboRIValorLiquidosEspesadosConConsistencia
                requiereNutricionEnteral
                nadaPorBoca
                justificacionNadaPorBoca
            }
            videodeglucionAdjunto{
                contentType 
                titulo
                archivo
                extension
            }
        }
    }
`;